module.exports = __webpack_public_path__ + "assets/img/b38e76c225dfe6d3633274f619d0ec95.png";